import React from 'react';
import getColor from '../utils/interpolateColor';

const BG_GREY = '#e8eaea';

/**
 * Ring gauge tuned for PublicDishInfoPage: larger usable inner area, scaled type, inset from stroke.
 * Keeps {@link CircleProgressChart} unchanged for StatisticScoreCard and elsewhere.
 */
const PublicDishCircleProgressChart = ({
  name,
  score,
  originalSize = 280,
  originalRadius = 96,
  strokeWidth = 16,
  reductionFactor = 1,
  mtop = 0,
  mbottom = 10,
  strokeClr = BG_GREY,
  centerContentInsetRatio = 0.16,
  t,
}) => {
  const circleSize = originalSize * reductionFactor;
  const circleRadius = originalRadius * reductionFactor;
  const center = circleSize / 2;
  const r = circleRadius - strokeWidth / 2;
  const circumference = 2 * Math.PI * r;
  const clamped = Math.max(0, Math.min(100, Number(score) ?? 0));
  const strokeDashoffset =
    clamped === 100
      ? 0
      : circumference - (clamped / 100) * circumference;
  const primeColor = getColor(clamped);

  const inset = Math.max(0, circleSize * centerContentInsetRatio);
  const scoreFontPx = Math.round(
    Math.min(Math.max(circleSize * 0.125, 11), 40)
  );
  const captionFontPx = Math.round(
    Math.min(Math.max(circleSize * 0.042, 8), 13)
  );
  const captionMarginTop = Math.max(3, Math.round(circleSize * 0.022));

  return (
    <div
      className="relative flex justify-center items-center"
      style={{
        height: circleSize,
        width: circleSize,
        marginTop: mtop || 0,
        marginBottom: mbottom || 0,
      }}
    >
      <svg
        width={circleSize}
        height={circleSize}
        viewBox={`0 0 ${circleSize} ${circleSize}`}
        className="absolute"
      >
        <circle
          cx={center}
          cy={center}
          r={r}
          fill="none"
          stroke={strokeClr}
          strokeWidth={strokeWidth}
        />
        <circle
          cx={center}
          cy={center}
          r={r}
          fill="none"
          stroke={clamped > 0 ? primeColor : 'none'}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          style={{
            transform: 'rotate(-90deg)',
            transformOrigin: 'center',
            transition: 'stroke-dashoffset 0.6s ease 0s',
          }}
        />
      </svg>
      <div
        className="absolute flex flex-col justify-center items-center text-center box-border"
        style={{
          top: inset,
          left: inset,
          right: inset,
          bottom: inset,
          lineHeight: 1.12,
          fontWeight: 800,
          padding: Math.max(2, Math.round(circleSize * 0.02)),
        }}
      >
        <span style={{ fontSize: scoreFontPx, fontWeight: 800, lineHeight: 1.05 }}>
          {clamped}
        </span>
        <span
          style={{
            display: 'block',
            fontSize: captionFontPx,
            fontWeight: 700,
            marginTop: captionMarginTop,
            letterSpacing: '0.04em',
            opacity: 0.92,
          }}
        >
          {t ? t('POÄNG') : 'POÄNG'}
        </span>
      </div>
    </div>
  );
};

export default PublicDishCircleProgressChart;
